import { render, staticRenderFns } from "./VuexStateInspector.vue?vue&type=template&id=04134cfe&scoped=true&"
import script from "./VuexStateInspector.vue?vue&type=script&lang=js&"
export * from "./VuexStateInspector.vue?vue&type=script&lang=js&"
import style0 from "./VuexStateInspector.vue?vue&type=style&index=0&id=04134cfe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04134cfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04134cfe')) {
      api.createRecord('04134cfe', component.options)
    } else {
      api.reload('04134cfe', component.options)
    }
    module.hot.accept("./VuexStateInspector.vue?vue&type=template&id=04134cfe&scoped=true&", function () {
      api.rerender('04134cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/vuex/VuexStateInspector.vue"
export default component.exports